var _line, _polyline, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ql-color-label ql-stroke ql-transparent",
    x1: 3,
    x2: 15,
    y1: 15,
    y2: 15
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "ql-stroke",
    points: "5.5 11 9 3 12.5 11"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 11.63,
    x2: 6.38,
    y1: 9,
    y2: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.6c2b4048a0fa0cd5f2c5d920eb95ee48.svg";
export { ForwardRef as ReactComponent };